import { ReactElement } from 'react';
import {
	IDENTIFIER_TYPES,
	NEW_NON_EMPLOYEE_KEYS,
} from 'pages/NewNonEmployee/_const';
import CustomSelect from '../base/CustomSelect';

/**
 * Prompt user for input: identifier type
 * @returns {ReactElement} select prompting for identifier type
 */
const IdentifierType = () => {
	return (
		<CustomSelect
			name={NEW_NON_EMPLOYEE_KEYS.IDENTIFIER_TYPE}
			label='Identifier Type'
			required
			options={[
				{
					value: IDENTIFIER_TYPES.AADHAR_NUMBER,
					label: 'Aadhaar Number',
				},
				{
					value: IDENTIFIER_TYPES.DRIVERS_LICENSE,
					label: "Driver's License",
				},
				{
					value: IDENTIFIER_TYPES.EU_IDENTIFIER,
					label: 'EU Identifier',
				},
				{
					value: IDENTIFIER_TYPES.MICROSOFT_ID,
					label: 'Microsoft ID',
				},
				{
					value: IDENTIFIER_TYPES.PARTNER_ID,
					label: 'Partner ID',
				},
				{
					value: IDENTIFIER_TYPES.PASSPORT,
					label: 'Passport',
				},
				{
					value: IDENTIFIER_TYPES.SOCIAL_SECURITY_NUMBER,
					label: 'Social Security Number (SSN)',
				},
				{
					value: IDENTIFIER_TYPES.UNIVERSITY_ID,
					label: 'University Student ID',
				},
				{
					value: IDENTIFIER_TYPES.VISA,
					label: 'Visa',
				},
			]}
		/>
	);
};
export default IdentifierType;
